import { useContext } from "react";

import { BoardUsersContext, IBoardUsersContext } from "./BoardUsersContext";

export function useBoardUsers(): IBoardUsersContext {
  const context = useContext(BoardUsersContext);
  if (!context) {
    throw new Error("useBoardUsers must be used within a BoardUsersProvider");
  }

  return context;
}
